import NECKLACE from '../Assets/necklace.png'
import BRACLETS from '../Assets/braclets.png'
import EARRING from '../Assets/earring.png'
import { useNavigate } from 'react-router-dom'
import Hero from './Hero'

const Gallery = () => {

     const nav = useNavigate()
         return (
            <>
                    <Hero />
             <section id="gallery" className="py-16 bg-gray-100">
                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                     <h2 className="text-3xl font-bold text-center mb-8">Our Collection</h2>
                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                     
                             <div  className="overflow-hidden rounded-lg shadow-md">
                                 <img src={NECKLACE} alt="necklace" className="w-full h-64 object-cover gallery-img" onClick={e  => nav('/necklaces')} />
                             </div>
                              <div  className="overflow-hidden rounded-lg shadow-md">
                                 <img src={BRACLETS} alt="necklace" className="w-full h-64 object-cover gallery-img" onClick={e  => nav('/bracelets')} />
                             </div>
                            <div  className="overflow-hidden rounded-lg shadow-md">
                                 <img src={EARRING} alt="necklace" className="w-full h-64 object-cover gallery-img" onClick={e  => nav('/earrings')} />
                             </div>
                     </div>
     
                     
                 </div>
             </section>
             </>
         );
  
}

export default Gallery